import { useAtom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

export const RecentMarketsStorageKey = 'moxieRecentMarkets'
export const recentMarketsAtom = atomWithStorage<Record<string, string[]>>(RecentMarketsStorageKey, {}, undefined, {
    getOnInit: true,
})

export const useRecentMarkets = (clientCode: string) => {
    const [recentMarkets] = useAtom(recentMarketsAtom)
    return recentMarkets[clientCode] || []
}

export const useAddRecentMarket = () => {
    const [recentMarkets, setRecentMarkets] = useAtom(recentMarketsAtom)

    const addMarket = (clientCode: string, marketCode: string) => {
        // Make sure there are no dupes, max of 3 (so that the incoming market means an actual max of 4)
        const filteredMarkets = (recentMarkets[clientCode]?.filter(code => code !== marketCode) || []).slice(0, 3)
        const updatedMarkets = {
            ...recentMarkets,
            [clientCode]: [marketCode, ...filteredMarkets],
        }
        setRecentMarkets(updatedMarkets)
    }

    return addMarket
}

export const useClearRecentMarket = () => {
    const [recentMarkets, setRecentMarkets] = useAtom(recentMarketsAtom)

    const clearMarket = (clientCode: string, marketCode: string) => {
        const updatedMarkets = {
            ...recentMarkets,
            [clientCode]: recentMarkets[clientCode]?.filter(code => code !== marketCode) || [],
        }
        setRecentMarkets(updatedMarkets)
    }

    return clearMarket
}
